import React, { useEffect } from "react";
import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Button, Message, Input } from "../../../BP2Components";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { getListStructure } from "services/api/Api";
import { showName, validateTranslations } from "@util/Scripts";
import { useWidgetSettings } from "@util/customHooks";
import { useIntl } from "react-intl";

const { Option } = Select;

const RankingSettings = (props) => {
   const { value, columns, data } = props;
   const intl = useIntl();
   const dispatch = useDispatch();
   const { allLanguages } = useSelector(({ settings }) => settings);
   const { settings, setSettings, handleChange, syncTranslations } = useWidgetSettings(
      { ...value, columns },
      {
         sync: [
            {
               keyField: "rankingHeaderTranslationKey",
               category: "ranking.name",
               valuePrefix: "name",
            },
         ],
         translations: [{ translationKey: value.rankingHeaderTranslationKey }],
      },
   );

   const handleSubmit = (e) => {
      e.preventDefault();

      const validTranslations = validateTranslations(settings);

      if (!validTranslations) {
         Message.error(intl.formatMessage({ id: "widget.invalidTranslations" }));
         return;
      }
      dispatch(setWidgetInSheetParams(settings));
      syncTranslations(settings);
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };
   const handleChangeList = (e) => {
      getListStructure(settings.listId).then((res) => {
         const responseData = res.data.getStructure;
         if (responseData.columns) {
            setSettings({
               ...settings,
               columns: responseData.columns,
            });
         }
      });
   };
   const options =
      settings && settings.columns != null
         ? settings.columns.map((col) => (
              <Option key={col.label} value={col.label}>
                 {col.label}
              </Option>
           ))
         : null;

   useEffect(() => {
      const updates = {};
      allLanguages.forEach((item) => {
         const key = `name${item.language}`;
         const val = settings[key];
         if (typeof val === "object") {
            updates[key] = "";
         } else if (typeof val !== "string") {
            updates[key] = showName(item.language, value.rankingHeaderTranslationKey, data);
         }
      });
      if (Object.keys(updates).length > 0) {
         setSettings((prev) => ({ ...prev, ...updates }));
      }
   }, [settings.namesp, settings.nameen, settings.namepl, settings.namede]);

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div className="widget-settings__inner">
                  <label className="widget-settings__inner__label" key="title">
                     <IntlMessages id="settings.listId" />:
                     <div style={{ display: "flex" }}>
                        <Input
                           type="text"
                           name="listId"
                           defaultValue={value.listId}
                           onChange={(e) => handleChange(e.target.value, e.target.name)}
                           style={{ width: "100px" }}
                        />
                        <Button className="gx-ml-1" buttonType="primary" onClick={handleChangeList}>
                           <IntlMessages id="settings.changeId" />
                        </Button>
                     </div>
                  </label>
                  <label
                     key="rankingHeaderTranslationKey"
                     className="widget-settings__inner__label"
                  >
                     <IntlMessages id="settings.titleTranslationKey" />:
                     <Input
                        type="text"
                        name="rankingHeaderTranslationKey"
                        defaultValue={value.rankingHeaderTranslationKey}
                        onChange={handleChange}
                        style={{ width: "220px" }}
                     />
                  </label>
                  {allLanguages.map((item) => (
                     <label key={item.language} className="widget-settings__inner__label">
                        <IntlMessages id={`widgetTitle${item.language}`} />:
                        <Input
                           type="translation"
                           className="translationName"
                           name={`name${item.language}`}
                           defaultValue={
                              settings[`name${item.language}`]
                                 ? settings[`name${item.language}`]
                                 : showName(
                                      `${item.language}`,
                                      value.rankingHeaderTranslationKey,
                                      data,
                                   )
                           }
                           onChange={(e) => handleChange(e.target.value, e.target.name)}
                           style={{ width: "300px" }}
                        />
                     </label>
                  ))}
                  <label key="columnToDisplayUser" className="widget-settings__inner__label">
                     <IntlMessages id="settings.columnToDisplayUser" />:
                     <Select
                        defaultValue={
                           settings.columnToDisplayUser !== null
                              ? settings.columnToDisplayUser
                              : "----Select----"
                        }
                        style={{ width: 220 }}
                        onChange={(v) => handleChange(v, "columnToDisplayUser")}
                     >
                        {options}
                     </Select>
                  </label>
                  <label key="columnToDisplayPosition" className="widget-settings__inner__label">
                     <IntlMessages id="settings.columnToDisplayPosition" />:
                     <Select
                        defaultValue={
                           settings.columnToDisplayPosition !== null
                              ? settings.columnToDisplayPosition
                              : "----Select----"
                        }
                        style={{ width: 220 }}
                        onChange={(v) => handleChange(v, "columnToDisplayPosition")}
                     >
                        {options}
                     </Select>
                  </label>{" "}
                  <label key="columnToDisplayPoints" className="widget-settings__inner__label">
                     <IntlMessages id="settings.columnToDisplayPoints" />:
                     <Select
                        defaultValue={
                           settings.columnToDisplayPoints !== null
                              ? settings.columnToDisplayPoints
                              : "----Select----"
                        }
                        style={{ width: 220 }}
                        onChange={(v) => handleChange(v, "columnToDisplayPoints")}
                     >
                        {options}
                     </Select>
                  </label>{" "}
                  <label className="widget-settings__inner__label" key="itemsPerPage">
                     <IntlMessages id="settings.itemsPerPage" />:
                     <Input
                        type="number"
                        name="itemsPerPage"
                        onChange={(e) => handleChange(+e.target.value, "itemsPerPage")}
                        min={1}
                        style={{ width: "100px" }}
                        defaultValue={value.itemsPerPage}
                     />
                  </label>
               </div>
               <Button key="btn" buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default RankingSettings;
